import { call, put, getContext, takeLatest } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import { getLivestreamMessagesActionTypes } from "./actionTypes";
import {
  getLivestreamMessagesFailure,
  getLivestreamMessagesSuccess,
} from "@redux/livestreamMessages/actions";
import { normalizeLivestreamMessagesArray } from "@helpers/livestreamMessages";

const getLivestreamMessagesAsync = ({
  LivestreamsService,
  uniqueKey,
  params,
}) => {
  if (!LivestreamsService) {
    console.log("Required services does not exist");
    return null;
  }

  return LivestreamsService.getLivestreamMessages(uniqueKey, params);
};

function* getLivestreamMessages({ payload }) {
  const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);

  try {
    const { uniqueKey, isNextPage, ...params } = payload;
    const { data, pagination } = yield call(getLivestreamMessagesAsync, {
      LivestreamsService,
      uniqueKey,
      params,
    });

    const { entities, result: allMessages } =
      normalizeLivestreamMessagesArray(data);
    const { messages: messagesById } = entities;
    const { totalCount, nextOffset } = pagination;
    yield put(
      getLivestreamMessagesSuccess({
        allMessages,
        messagesById,
        totalCount,
        isNextPage,
        nextOffset,
      }),
    );
  } catch ({ error }) {
    yield put(getLivestreamMessagesFailure(error));
  }
}

export function* watchGetLivestreamMessages() {
  yield takeLatest(
    getLivestreamMessagesActionTypes.request,
    getLivestreamMessages,
  );
}
